// @ts-check
import { css, jsx } from '@emotion/core';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';

import Link from '@/src/shared/components/Link';
import Table from '@/src/shared/components/Table';
import { colors } from '@/styles';
import request from '@/utils/axios';
import useStaffProfiles from "./useStaffProfiles";

const style = {
  name: css`
    color: ${colors.secondaryBlue};
    font-weight: bolder;
  `,
  sorterText: css`
    font-weight: bolder;
    margin-bottom: 0px;
  `,
};

const StateSort = () => {
  const { data, loading } = useStaffProfiles('state');

  return (
    <Table
      columns={columns}
      dataSource={data}
      rowKey={record => `${record.personId}-${record.state}`}
      loading={loading}
      showHeader={false}
      pagination={false}
      scroll={{ x: 580 }}
      css={css`
        .ant-table-row-cell-break-word {
          white-space: normal !important;
        }
      `}
    />
  );
};

/** @type {import("./useStaffProfiles").StaffProfileColumn[]} */
const columns = [
  {
    title: 'State',
    dataIndex: 'state',
    render: text => {
      return <p css={style.sorterText}>{text}</p>;
    },
    width: '150px',
  },
  {
    title: 'Name',
    dataIndex: 'name',
    render: (text, record) => {
      return (
        <Link anchor css={style.name} href={`mailto:${record.emailAddress}`}>
          {text}
        </Link>
      );
    },
    width: '250px',
  },
  {
    title: 'Phone',
    dataIndex: 'phone',
    key: 'Phone',
    render: text => {
      return (
        <Link anchor href={`tel:${text}`}>
          {text}
        </Link>
      );
    },
    width: '180px',
  },
];

export default StateSort;
